// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const baseRoute = '/vehicle-device-management'

export const VehicleDeviceManagementAdminAreaRoutes = {
  route: baseRoute,
  Details: {
    route: '/:vehicleId',
    Info: {
      route: '/info',
      Basic: {
        route: '/basic',
      },
      Equipment: {
        route: '/equipment',
      },
      Components: {
        route: '/components',
      },
      Telematic: {
        route: '/telematic',
      },
    },
    Capabilities: {
      route: '/capabilities',
    },
    Client: {
      route: '/client',
    },
    Maintenance: {
      route: '/maintenance',
    },
    Onboarding: {
      route: '/onboarding',
    },
    VehicleInformation: {
      route: '/vehicle-information',
      Components: {
        route: '/components',
      },
      TelecommunicationUnit: {
        route: '/telecommunication-unit',
      },
    },
    ModB2bProvisioning: {
      route: '/mod-b2b-provisioning',
    },
    History: {
      route: '/history',
    },
  },
}

export const TransformedVehicleDeviceManagementAreaRoutes = transformRoutes(
  VehicleDeviceManagementAdminAreaRoutes,
)
